import { CommodityDetail } from 'features/contracts/enums/commodityDetail';
import CommodityIcon from 'features/shared/components/icons/CommodityIcon';
import React from 'react';

import styles from "./topBarIcon.module.scss";
import { useInjection } from 'infrastructure/ioc/ioc.react';
import ICustomerService from 'features/customer/services/ICustomerService';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import { useHistory } from 'react-router-dom';
import { getContractsRoute } from 'features/shared/helpers/routeHelper';

type Props = {
  commodityDetail: CommodityDetail;
  active: boolean;
}

const TopBarCommodityIcon = ({ commodityDetail, active }: Props) => {
  // DI
  const customerService = useInjection<ICustomerService>(IocTypes.CustomerService);
  
  // router
  const history = useHistory();

  // handlers
  const iconClickHandler = () => { 
    if (active) {
      customerService.storeContractsFilterParams(commodityDetail);
      history.push(getContractsRoute());
    }
  }

  // render
  return (
    <div 
      className={`${styles.iconItem}${active ? ` ${styles.active}`: ""}`}
      onClick={iconClickHandler}
    >
      <CommodityIcon commodityDetail={commodityDetail} />
    </div>
  )
}

export default TopBarCommodityIcon;